export function deferTask(task: () => any): void {
    setTimeout(() => task(), 0);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/defer-task.ts